import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const selCls = "h-9 w-full rounded-md border border-slate-700 bg-slate-950 px-2 text-sm text-slate-100";

export function ExpenseDialog({ initial, categories, bases, onSave, onClose }) {
  const [f, setF] = useState(initial);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try { await onSave({ ...f, value: Number(String(f.value).replace(",", ".")) }); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-lg border-slate-800 bg-slate-900 text-slate-100" data-testid="expense-dialog">
        <DialogHeader><DialogTitle>{f.kind === "receita" ? (f.id ? "Editar faturamento" : "Lançar faturamento") : (f.id ? "Editar despesa" : "Nova despesa")}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 space-y-1.5">
            <Label className="text-slate-300">Descrição</Label>
            <Input value={f.description} onChange={set("description")} placeholder={f.kind === "receita" ? "Ex: Repasse da plataforma" : "Ex: Aluguel da base"} data-testid="expense-description" className="border-slate-700 bg-slate-950 text-slate-100" />
          </div>
          <div className="col-span-2 space-y-1.5">
            <Label className="text-slate-300">Categoria</Label>
            <Input value={f.category} onChange={set("category")} list="expense-categories" placeholder="Escolha ou digite uma nova" data-testid="expense-category" className="border-slate-700 bg-slate-950 text-slate-100" />
            <datalist id="expense-categories">{categories.map((c) => <option key={c} value={c} />)}</datalist>
          </div>
          {f.kind !== "receita" && (
          <div className="space-y-1.5">
            <Label className="text-slate-300">Tipo</Label>
            <select value={f.type} onChange={set("type")} data-testid="expense-type" className={selCls}>
              <option value="fixa">Fixa</option>
              <option value="variavel">Variável</option>
            </select>
          </div>
          )}
          <div className={`space-y-1.5 ${f.kind === "receita" ? "col-span-2" : ""}`}>
            <Label className="text-slate-300">Valor (R$)</Label>
            <Input type="number" step="0.01" min="0" value={f.value} onChange={set("value")} data-testid="expense-value" className="border-slate-700 bg-slate-950 font-mono text-slate-100" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Data</Label>
            <Input type="date" value={f.date} onChange={set("date")} data-testid="expense-date" className="border-slate-700 bg-slate-950 text-slate-100" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Base</Label>
            <select value={f.base_id || ""} onChange={set("base_id")} data-testid="expense-base" className={selCls}>
              <option value="">Todas as bases</option>
              {bases.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
          <label className="col-span-2 flex cursor-pointer items-center gap-2 text-sm text-slate-300">
            <Checkbox checked={!!f.recurring} onCheckedChange={(v) => setF((s) => ({ ...s, recurring: !!v }))} data-testid="expense-recurring" className="border-slate-500" />
            Repetir nos próximos meses
            <span className="text-xs text-slate-500">(todo mês, no mesmo dia, até você encerrar)</span>
          </label>
          {f.id && f.recurring && <p className="col-span-2 text-xs text-amber-300">A alteração vale para todos os meses desta despesa recorrente.</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" className="border-slate-700 text-slate-300" disabled={busy} onClick={onClose} data-testid="expense-cancel">Cancelar</Button>
          <Button className="bg-orange-500 text-white hover:bg-orange-600" disabled={busy} onClick={save} data-testid="expense-save">Salvar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
